import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Status } from '@df/core/status';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { AbstractCmsBlockComponent } from '../block/abstract-cms-block.component';
import { CMS_NEWSLETTER_BLOCK_CONFIG } from './cms-newsletter-block.config';
import { NCmsNewsletterBlock } from './cms-newsletter-block.interface';

@Component({
    selector: 'cms-newsletter-block',
    templateUrl: 'cms-newsletter-block.component.html',
    styleUrl: './cms-newsletter-block.component.scss',
    standalone: true,
    imports: [
        ActionComponent,
        CommonModule,
        CheckboxComponent,
        DfImageDirective,
        FormsModule,
        ICmsClientModule,
        ResultComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsNewsletterBlockComponent>(CMS_NEWSLETTER_BLOCK_CONFIG)
export class CmsNewsletterBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: NCmsNewsletterBlock.IBlockDataContent;

    @Input()
    newsletter: boolean | number;

    @Input()
    submitButton = false;

    @Input()
    submitStatus?: Status;

    @Input()
    isSuccessPage?: boolean;

    @Output()
    newsletterChange = new EventEmitter<boolean>();

    @Output()
    submitted = new EventEmitter<void>();

    handleModelChange(value: boolean) {
        if (this.newsletter !== value) {
            this.newsletter = value;

            this.newsletterChange.emit(value);

            this.detectChanges();
        }
    }

    submit(): void {
        this.submitted.emit();
    }
}
